import { render, staticRenderFns } from "./UpgradeNotificationContent.vue?vue&type=template&id=b284e982&scoped=true"
import script from "./UpgradeNotificationContent.vue?vue&type=script&lang=js"
export * from "./UpgradeNotificationContent.vue?vue&type=script&lang=js"
import style0 from "./UpgradeNotificationContent.vue?vue&type=style&index=0&id=b284e982&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b284e982",
  null
  
)

export default component.exports